import { render } from "./irrigationController.vue?vue&type=template&id=48ab3f80&scoped=true"
import script from "./irrigationController.vue?vue&type=script&lang=js"
export * from "./irrigationController.vue?vue&type=script&lang=js"

import "./irrigationController.vue?vue&type=style&index=0&id=48ab3f80&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ab3f80"]])

export default __exports__